const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[+()\d\s.-]+$/;

const required = (value, label) =>
  value.trim() ? "" : `${label} is required`;
const minimum = (value, length, label) =>
  value.trim().length >= length
    ? ""
    : `${label} must contain at least ${length} characters`;

export const validateContactForm = (values) => {
  const errors = {};

  errors.name =
    required(values.name, "Name") || minimum(values.name, 2, "Name");
  errors.email = required(values.email, "Email")
    ? "Email is required"
    : EMAIL_PATTERN.test(values.email.trim())
      ? ""
      : "A valid email address is required";
  errors.phone =
    values.phone.trim() &&
    (values.phone.trim().length < 7 ||
      values.phone.trim().length > 30 ||
      !PHONE_PATTERN.test(values.phone.trim()))
      ? "Enter a valid phone number"
      : "";
  errors.subject =
    required(values.subject, "Subject") ||
    minimum(values.subject, 2, "Subject");
  errors.message =
    required(values.message, "Message") ||
    minimum(values.message, 10, "Message");

  return Object.fromEntries(
    Object.entries(errors).filter(([, message]) => message),
  );
};

export const validateReservationForm = (values) => {
  const errors = {};

  errors.name =
    required(values.name, "Name") || minimum(values.name, 2, "Name");
  errors.email = required(values.email, "Email")
    ? "Email is required"
    : EMAIL_PATTERN.test(values.email.trim())
      ? ""
      : "A valid email address is required";
  errors.phone = required(values.phone, "Phone number")
    ? "Phone number is required"
    : values.phone.trim().length < 7 ||
        values.phone.trim().length > 30 ||
        !PHONE_PATTERN.test(values.phone.trim())
      ? "Enter a valid phone number"
      : "";
  errors.address =
    required(values.address, "Address") ||
    minimum(values.address, 5, "Address");
  errors.date =
    values.date.trim() && !/^\d{2}\/\d{2}\/\d{4}$/.test(values.date)
      ? "Preferred date must use DD/MM/YYYY format"
      : "";

  return Object.fromEntries(
    Object.entries(errors).filter(([, message]) => message),
  );
};

export const toIsoDate = (displayDate) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(displayDate);
  return match ? `${match[3]}-${match[2]}-${match[1]}` : displayDate;
};

export const getApiFieldErrors = (error) =>
  Object.fromEntries(
    (error?.details ?? [])
      .filter((detail) => detail.field && detail.message)
      .map((detail) => [detail.field, detail.message]),
  );

export const getRequestErrorMessage = (
  error,
  fallback = "Something went wrong. Please try again.",
) => {
  if (error?.status && error?.message) return error.message;
  return fallback;
};
